import "./ui.css";

export default function EmptyState({ title, description }) {
  return (
    <div className="ui-empty-state">
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  );
}
